export default {
  "tab.title": "Context",
  "mobile.title": "Usage",
  "usage.tokens": "Tokens",
  "usage.usage": "Context",
  "usage.cost": "Cost",
  "usage.view": "View context usage",
  "systemPrompt.title": "System Prompt",
  "rawMessages.title": "Raw messages",
  "export.session": "Export session",
  "stats.session": "Session",
  "stats.messages": "Messages",
  "stats.provider": "Provider",
  "stats.model": "Model",
  "stats.limit": "Context Limit",
  "stats.totalTokens": "Total Tokens",
  "stats.usage": "Usage",
  "stats.inputTokens": "Input Tokens",
  "stats.outputTokens": "Output Tokens",
  "stats.reasoningTokens": "Reasoning Tokens",
  "stats.cacheTokens": "Cache Tokens (read/write)",
  "stats.userMessages": "User Messages",
  "stats.assistantMessages": "Assistant Messages",
  "stats.totalCost": "Total Cost",
  "stats.sessionCreated": "Session Created",
  "stats.lastActivity": "Last Activity",
  "export.success.title": "Session exported",
  "export.success.description": "Saved session to {{filename}}",
  "export.failed.title": "Failed to export session",
  "export.failed.description": "An error occurred while exporting the session",
}
